<ng-container *ngIf="loading">
  <div class="progress-loader">
    <div class="spinner">
      <mat-spinner strokeWidth="3" diameter="150"></mat-spinner>
      <div
        style="
          position: relative;
          top: -95px;
          left: 3px;
          text-align: center;
          width: 150px;
        "
      ></div>
    </div>
  </div>
</ng-container>

<section class="filtering">
  <div class="left" style="vertical-align: -webkit-baseline-middle">
    <h2>All Builds</h2>
  </div>
  <div class="center">&nbsp;</div>
  <div class="right" *ngIf="showRefresh" style="vertical-align: text-top">
    <button
      class="button_small"
      mat-button
      (click)="refreshBuilds()"
      [disabled]="disableRefresh"
      style="
        width: 105%;
        font-size: 14px !important;
        margin-bottom: 10px;
        font-weight: 400 !important;
      "
    >
      Refresh Build List Sync Data
      <fa-icon [icon]="faRotate" mat-button class="refreshIcon"></fa-icon>
    </button>
  </div>
</section>

<!-- FILTER BAR -->
<section class="filtering">
  <div class="left"></div>
  <div class="center" *ngIf="showData">
    <button
      class="button_small"
      mat-button
      [disabled]="selection.selected.length < 1 || disableButtons"
      (click)="openImportDialog(true)"
    >
      Enable Import
    </button>
    <button
      class="button_small"
      mat-button
      [disabled]="selection.selected.length < 1 || disableButtons"
      (click)="openImportDialog(false)"
    >
      Disable Import
    </button>
    <button
      class="button_small"
      mat-button
      [disabled]="selection.selected.length < 1 || disableButtons"
      (click)="openCMSImportDialog()"
    >
      Import from CMS
    </button>
  </div>
  <div class="right" *ngIf="showData">
    <span class="error" *ngIf="error">{{ error }}</span>
    <span class="error" *ngIf="!error">&nbsp;</span>

    <div class="searchBox">
      <form [formGroup]="canvasForm">
        <mat-form-field style="width: 80%">
          <input
            matInput
            placeholder="filter builds"
            formControlName="searchTerm"
            name="Search"
            (keyup)="applyFilter($event)"
            aria-label="Search"
          />
        </mat-form-field>

        <fa-icon
          [icon]="faSearch"
          matSuffix
          mat-button
          class="searchIcon"
        ></fa-icon>
      </form>
    </div>
  </div>
</section>

<ng-container *ngIf="!showData">
  <div class="loading-spinner">
    <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    Loading Builds
  </div>
</ng-container>

<div [hidden]="!showData">
  <div [hidden]="dataSource && dataSource.length <= 0">
    <table mat-table [dataSource]="dataSource" matSort id="dataTable">
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell noItems" colspan="40">
          No Builds available to be shown
        </td>
      </tr>

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <fa-icon
            [icon]="faEmptySet"
            class="clearIcon"
            mat-button
            (click)="masterToggle()"
          ></fa-icon>
        </th>
        <th mat-header-cell *matHeaderCellDef style="font-size: 10px">
          Select Fields
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            color="primary"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="build">
          Build Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.build }}</td>
      </ng-container>

      <!-- Product Column -->
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="product">
          Product
        </th>
        <td mat-cell *matCellDef="let element">{{ element.product }}</td>
      </ng-container>

      <!-- category Column -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="category">
          Category
        </th>
        <td mat-cell *matCellDef="let element">{{ element.category }}</td>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="cmsEnabled">
          CMS Status
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="enabled" *ngIf="element.cmsEnabled">Enabled</span>
          <span class="disabled" *ngIf="!element.cmsEnabled">Disabled</span>
        </td>
      </ng-container>

      <!-- sync Column -->
      <ng-container matColumnDef="sync">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="syncStatus">
          Import Status
        </th>

        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <span
            (click)="element.lastImportStatus !== 'None'
              ? openSyncStatusDialog($event, element.category, element.build, element.category_id)
              : null"
            [ngClass]="{
              'import-failed': element.lastImportStatus == 'Failed',
              'import-complete': element.lastImportStatus == 'Complete',
              'import-partially-complete': element.lastImportStatus == 'Partially Complete'
            }"
          >{{ element.lastImportStatus }}</span>
        </td>
      </ng-container>

      <!-- Last Import Column -->
      <ng-container matColumnDef="lastImport">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="syncTime">
          Last CMS Import
        </th>
        <td mat-cell *matCellDef="let element">
          {{ formatModified(element.lastImportDateTime) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="selection.toggle(row)"
      ></tr>
    </table>

    <span class="selectedItems" *ngIf="selection.selected.length > 0"
      >Currently {{ selection.selected.length }} Build(s) selected</span
    >
    <mat-paginator
      [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
